import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import NavFlechas from "@/components/NavFlechas";
import { fechaSolo, ELIMINAR_MODELOS_HABILITADO } from "@/lib/constants";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import {
  Pencil, Check, X, Lock, Trash2, RotateCcw, Copy, MoreHorizontal, FolderSymlink, Ban,
} from "lucide-react";

export default function ModeloHeader({
  m, identEdit, identDraft, setIdentDraft, guardarIdentidad, setIdentEdit,
  puedeSeccion, bloqueada, puedeAccion,
  reabrirColeccion, eliminarModelo, abrirDuplicar, abrirReasignar, abrirReajuste, abrirDepurado, abrirReactivar,
  irHermano, hermanoPrevDisabled, hermanoNextDisabled,
}) {
  return (
    <div className="flex items-start justify-between mb-6 flex-wrap gap-3">
      <div className="min-w-0">
        {identEdit ? (
          <div className="flex items-center gap-2 flex-wrap">
            <Input value={identDraft.nombre} onChange={(e) => setIdentDraft({ ...identDraft, nombre: e.target.value })} className="h-9 w-56" data-testid="ident-nombre-input" />
            <Input value={identDraft.sku} onChange={(e) => setIdentDraft({ ...identDraft, sku: e.target.value })} placeholder="SKU (opcional)" className="h-9 w-40 font-mono" data-testid="ident-sku-input" />
            <Button size="sm" className="h-9" onClick={guardarIdentidad} data-testid="ident-save-button"><Check size={14} className="mr-1" />Guardar</Button>
            <Button size="sm" variant="ghost" className="h-9 text-slate-500" onClick={() => setIdentEdit(false)}><X size={14} /></Button>
          </div>
        ) : (
          <div className="flex items-center gap-3 flex-wrap">
            <h1 className="font-head text-3xl font-extrabold tracking-tight" data-testid="modelo-title">{m.nombre}</h1>
            <span className="font-mono text-sm px-2 py-1 rounded-md bg-slate-100 text-slate-600">{m.sku || "sin SKU"}</span>
            {puedeSeccion("identidad") && (
              <button onClick={() => { setIdentDraft({ nombre: m.nombre, sku: m.sku || "" }); setIdentEdit(true); }} className="text-slate-400 hover:text-blue-600 transition-colors" data-testid="edit-identidad-button"><Pencil size={15} /></button>
            )}
          </div>
        )}
        <p className="text-slate-500 mt-1">{m.organizacion.categoria} · {m.organizacion.genero} · {m.organizacion.linea || "Sin línea"}</p>
        {m.created_at && (
          <p className="text-xs text-slate-400 mt-1" data-testid="modelo-fecha-solicitud">Solicitado: {fechaSolo(m.created_at)}</p>
        )}
        {m.depurado && (
          <span className="inline-flex items-center gap-1 mt-2 text-xs font-semibold px-2.5 py-1 rounded-full bg-slate-200 text-slate-700" data-testid="modelo-depurado-badge">
            <Ban size={12} /> Depurado
          </span>
        )}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {irHermano && (
          <NavFlechas
            testid="modelo-nav"
            labelPrev="Modelo anterior"
            labelNext="Modelo siguiente"
            onPrev={() => irHermano(-1)}
            onNext={() => irHermano(1)}
            prevDisabled={hermanoPrevDisabled}
            nextDisabled={hermanoNextDisabled}
          />
        )}
        {bloqueada && (
          <span className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-emerald-100 text-emerald-800" data-testid="modelo-bloqueado-badge">
            <Lock size={12} /> Colección completada
          </span>
        )}
        {bloqueada && puedeAccion("reabrir_colecciones") && (
          <Button variant="outline" size="sm" className="rounded-lg" onClick={reabrirColeccion} data-testid="reabrir-desde-modelo">
            <RotateCcw size={14} className="mr-1" /> Reabrir colección
          </Button>
        )}
        {ELIMINAR_MODELOS_HABILITADO && puedeAccion("eliminar_modelos") && (
          <Button variant="outline" size="sm" className="rounded-lg text-red-600 border-red-200 hover:bg-red-50" onClick={eliminarModelo} data-testid="eliminar-modelo-button">
            <Trash2 size={14} className="mr-1" /> Eliminar
          </Button>
        )}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button size="sm" className="rounded-lg" data-testid="acciones-menu-button">
              <MoreHorizontal size={15} className="mr-1" /> Acciones
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-52">
            {puedeAccion("duplicar_modelos") && (
              <DropdownMenuItem onClick={abrirDuplicar} data-testid="accion-duplicar">
                <Copy size={15} className="mr-2" /> Duplicar
              </DropdownMenuItem>
            )}
            <DropdownMenuItem onClick={abrirReasignar} data-testid="accion-reasignar">
              <FolderSymlink size={15} className="mr-2" /> Reasignar colección
            </DropdownMenuItem>
            {puedeAccion("hacer_reajuste") && (
              <DropdownMenuItem onClick={abrirReajuste} data-testid="accion-reajuste">
                <RotateCcw size={15} className="mr-2" /> Reajuste
              </DropdownMenuItem>
            )}
            {puedeAccion("hacer_depurado") && !m.depurado && (
              <DropdownMenuItem onClick={abrirDepurado} data-testid="accion-depurado">
                <Ban size={15} className="mr-2" /> Depurado
              </DropdownMenuItem>
            )}
            {puedeAccion("hacer_depurado") && m.depurado && (
              <DropdownMenuItem onClick={abrirReactivar} data-testid="accion-reactivar">
                <RotateCcw size={15} className="mr-2" /> Reactivar
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
